import { useEffect, useState } from 'react';
import "react-multi-carousel/lib/styles.css";
import Select from 'react-select';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Grid, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { useTranslation } from '@refinedev/core';
import ApiService from 'utills/ApiService';
import DateRangePicker from 'components/wps/DateRangePicker';
import { ArrowDownIcon, ArrowLeftIcon, ArrowRightIcon, ArrowUpIcon } from '@heroicons/react/outline';
import CarouselMobile from "react-multi-carousel";
import { FullScreenLoading } from 'components/fullScreenLoading';
import toast from 'react-hot-toast';
import ChartOverview from '../chart';
import useWindowWidth from 'utills/InitWidthDevice';
import OverviewEvent from './event';
import { Breadcrumbs } from 'components/breadcrumbs';
import './overview.scss';
import React from 'react';
import { twMerge } from 'tailwind-merge';
import dayjs from 'dayjs';

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

const responsive = {
  desktop: {
    breakpoint: { max: 7000, min: 768 },
    items: 4
  },
  mobile: {
    breakpoint: { max: 768, min: 0 },
    items: 1
  }
};

const SLIDER_BREAKPOINT: any = {
  768: {
    slidesPerView: 2,
    spaceBetween: 15,
    slidesPerGroup: 3,
    allowTouchMove: false,
    grid: {
      rows: 1,
      fill: "row"
    }
  },
  860: {
    slidesPerView: 3,
    spaceBetween: 15,
    slidesPerGroup: 3,
    allowTouchMove: false,
    grid: {
      rows: 1,
      fill: "row"
    }
  },
  1140: {
    slidesPerView: 4,
    spaceBetween: 15,
    slidesPerGroup: 4,
    allowTouchMove: false,
    grid: {
      rows: 1,
      fill: "row"
    }
  },
};

const CustomDot = ({ ...rest }) => {
  const {
    active,
  } = rest;

  return (
    <div
      className={active ? "dot dot-active" : "dot dot-inactive"}
    >
    </div>
  );
};

interface WPSDashboardOverviewProps {
  hideDashboardLayout?: boolean;
}

const WPSDashboardOverview = ({ hideDashboardLayout = false }: WPSDashboardOverviewProps) => {
  const { translate, getLocale } = useTranslation();
  const language = getLocale();
  const [applyDate, setApplyDate] = useState({
    start: dayjs().startOf('year').format('YYYY-MM-DD'),
    end: dayjs().endOf('year').format('YYYY-MM-DD')
  });
  const [filter, setFilter] = useState(false);
  const [stats, setStats] = useState(null as any);
  const [growth, setGrowth] = useState(null as any);
  const [loading, setLoading] = useState(false);
  const [suffix, setSuffix] = useState('');
  const [page, setPage] = useState(0);
  const [fetchData, setFetchData] = useState(false);
  const [searchParams] = useSearchParams();
  const paramsObject = Object.fromEntries([...searchParams]);
  const navigate = useNavigate();
  const [initParams, setInitParams] = useState(true);
  const [showEvent, setShowEvent] = useState(false);
  const [eventStatus, setEventStatus] = useState('');
  const [dateType, setDateType] = useState('year');
  const [dateValue, setDateValue] = useState('');
  const [updateRoute, setUpdateRoute] = useState(false);
  const [symbolCurrency, setSymbolCurrency] = useState('đ');
  const [currentCurrency, setCurrentCurrency] = useState('vnd');
  const ticket_platform_option = [
    {
      value: '',
      label: translate('all_platform')
    },
    {
      value: "actiup",
      label: translate('actiup_platform')
    },
    {
      value: "partner",
      label: translate('partner_platform')
    }
  ] as any;
  const [ticketPlatform, setTicketPlatform] = useState(ticket_platform_option[0].value);
  // const [ticketPlatformDefault, setTicketPlatformDefault] = useState(null as any);
  const [showPlatform, setShowPlatform] = useState(false);
  const [eventSelected, setEventSelected] = useState('');
  const [eventID, setEventID] = useState('');
  const windowWidth = useWindowWidth();
  const [isMobile, setIsMobile] = useState(false);
  const breadcrumbItems = [
    {
      label: 'Dashboard',
      href: ''
    }
  ];

  const [token, setToken] = useState('');
  const [selectedPlatform, setSelectedPlatForm] = useState<{ label: string, value: string }>(ticket_platform_option[0]);

  useEffect(() => {
    const user = localStorage.getItem("USER");

    if (user) {
      const userData = JSON.parse(user);
      setToken(userData?.token);
    }
  }, []);

  useEffect(() => {
    if (windowWidth && windowWidth < 1024) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [windowWidth]);

  useEffect(() => {
    if (token !== '') {
      handleCheckShowPlatform();
    }
  }, [token]);

  const handleCheckShowPlatform = async () => {
    try {
      const result = await ApiService.get(`orders/whitelabel/existed`, token);

      if (result && result?.whitelabel_orders_existed) {
        setShowPlatform(true);
      }


    } catch (error: any) {
      // toast.error(error.message);
      console.log("Fetch check show platform failed:", error.message);
    }
  }

  useEffect(() => {
    const wsCurrency = localStorage.getItem('wsCurrency');

    if (wsCurrency && wsCurrency.toLowerCase() === 'usd') {
      setSymbolCurrency('$');
      setCurrentCurrency('usd');
    } else {
      setSymbolCurrency('đ');
      setCurrentCurrency('vnd');
    }
  }, []);


  useEffect(() => {
    if (initParams) {
      const keys = Object.keys(paramsObject);

      if (keys?.length > 0) {
        handleInitSearchValue();
      } else {
        setFilter(true);
        setShowEvent(true);
        setInitParams(false);
        // setTicketPlatformDefault(ticket_platform_option[0])
        setSelectedPlatForm(ticket_platform_option[0]);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initParams]);

  const handleInitSearchValue = () => {
    if (paramsObject.from_date && paramsObject.from_date !== '') {
      setApplyDate({
        start: paramsObject.from_date,
        end: paramsObject.to_date
      })
    }

    if (paramsObject.event_status && paramsObject.event_status !== '') {
      setEventStatus(paramsObject.event_status);
    }

    if (paramsObject.event_id && paramsObject.event_id !== '') {
      setEventID(paramsObject.event_id);
    }

    if (paramsObject.date_type && paramsObject.date_type !== '') {
      setDateType(paramsObject.date_type);
    }

    if (paramsObject.date_value && paramsObject.date_value !== '') {
      setDateValue(paramsObject.date_value);
    }

    // if (paramsObject.ticket_platform && paramsObject.ticket_platform !== '') {
    //   setTicketPlatform(paramsObject.ticket_platform);
    //   ticket_platform_option.forEach((item: any) => {
    //     if (item.value === paramsObject.ticket_platform) {
    //       setTicketPlatformDefault(item);
    //     }
    //   })
    // } else {
    //   setTicketPlatformDefault(ticket_platform_option[0]);
    // }

    if (paramsObject.ticket_platform && paramsObject.ticket_platform !== '') {
      setTicketPlatform(paramsObject.ticket_platform);

      ticket_platform_option.forEach((item: any) => {
        if (item.value === paramsObject.ticket_platform) {
          setSelectedPlatForm(item);
        }
      })
    } else {
      setSelectedPlatForm(ticket_platform_option[0]);
    }

    setFilter(true);
    setInitParams(false);

    const intervalShowEvent = setInterval(() => {
      setShowEvent(true);
      clearInterval(intervalShowEvent);
    }, 1000);

  }

  useEffect(() => {
    if (token !== '' && filter) {
      const intervalFetchData = setInterval(() => {
        setFetchData(true);
        clearInterval(intervalFetchData);
      }, 100);
    }
  }, [filter, token]);

  useEffect(() => {
    if (updateRoute) {
      handleUpdateRoute();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applyDate, eventStatus, dateType, dateValue, eventID, ticketPlatform]);

  const handleUpdateRoute = () => {
    const newSearchParams = new URLSearchParams(searchParams);

    newSearchParams.set('from_date', applyDate.start);
    newSearchParams.set('to_date', applyDate.end);
    newSearchParams.set('event_status', eventStatus);
    newSearchParams.set('event_id', eventID);
    newSearchParams.set('date_type', dateType);
    newSearchParams.set('date_value', dateValue);
    newSearchParams.set('ticket_platform', ticketPlatform);

    const newParamsObject = Object.fromEntries([...newSearchParams]);

    const keys = Object.keys(newParamsObject);
    let changeRoute = false;

    if (keys?.length > 0) {
      keys?.forEach((key: string) => {
        if (newParamsObject[key] !== '') {
          changeRoute = true;
        }
      });
    }

    if (changeRoute || !initParams) {
      navigate(`?${newSearchParams.toString()}`, { replace: true });
    }
  }

  useEffect(() => {
    if (fetchData) {
      fetchStats();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchData]);

  const fetchStats = async () => {
    setLoading(true);
    try {
      const result = await ApiService.get(`dashboards/orders/stats?from_date=${applyDate.start}&to_date=${applyDate.end}&currency=${currentCurrency}&ticket_platform=${ticketPlatform}`, token);

      if (result && result.stats) {
        setStats(result.stats);

        if (result.growth_rates && Object.keys(result.growth_rates).length > 0) {
          const keys = Object.keys(result.growth_rates);

          keys.forEach((item: any) => {
            if (result.growth_rates[item] !== "Infinity") {
              result.growth_rates[item] = result.growth_rates[item].toFixed(0);
              result.growth_rates[item] = result.growth_rates[item].toString();
            }
          });

          setGrowth(result.growth_rates);
        } else {
          setGrowth(null);
        }
      }

      setUpdateRoute(true);
    } catch (error: any) {
      // toast.error(error.message);
      console.log("Fetch stats failed:", error.message);
    }
    setFetchData(false);
    setLoading(false);
  }

  const shortenNumber = (num: number, type?: any) => {
    if (num > 0) {
      if (num >= 1000000000000) {
        let shortened = (num / 1000000000000) as any;
        shortened = (Math.floor(shortened * 10) / 10).toFixed(1);
        return shortened.endsWith('.0') ? shortened.slice(0, -2) + 'T' : shortened + 'T';
      } else if (num >= 1000000000) {
        let shortened = (num / 1000000000) as any;
        shortened = (Math.floor(shortened * 10) / 10).toFixed(1);
        return shortened.endsWith('.0') ? shortened.slice(0, -2) + 'B' : shortened + 'B';
      } else if (num >= 1000000) {
        let shortened = (num / 1000000) as any;
        shortened = (Math.floor(shortened * 10) / 10).toFixed(1);
        return shortened.endsWith('.0') ? shortened.slice(0, -2) + 'M' : shortened + 'M';
      } else if (num >= 1000) {
        let shortened = (num / 1000) as any;
        shortened = (Math.floor(shortened * 10) / 10).toFixed(1);
        return shortened.endsWith('.0') ? shortened.slice(0, -2) + 'K' : shortened + 'K';
      } else {
        if (type && type === 'number') {
          return num;
        } else {
          return num.toFixed(2);
        }
      }
    } else {
      return 0;
    }
  }

  const getSuffix = () => {
    switch (suffix) {
      case 'today':
        return translate('vs-yesterday');
      case 'yesterday':
        return translate('vs-previous-day');
      case 'l7d':
        return translate('l7d');
      case 'l30d':
        return translate('l30d');
      case '':
        return '';
      default:
        return suffix;
    }
  }

  const getGrowthValue = (value: any) => {
    let final_value = value;
    if (value.indexOf('-') !== -1) {
      final_value = value.slice(1);
    };

    return final_value;
  }

  // Update platform selected value when language change
  useEffect(() => {
    const updatePlaformSelect = () => {
      if (paramsObject?.ticket_platform && paramsObject?.ticket_platform !== '') {
        const currentPlatform = ticket_platform_option?.find((p: {value: string, name: string}) => {
          return p?.value === paramsObject?.ticket_platform;
        });

        console.log("Current platform:", currentPlatform);
        setSelectedPlatForm(currentPlatform);
      } else {
        setSelectedPlatForm(ticket_platform_option[0]);
      }
    };

    updatePlaformSelect();
  }, [language]);

  if (!initParams) {
    return (
      <div className="overview">
        {!hideDashboardLayout && <Breadcrumbs type="wps" breadcrumbItems={breadcrumbItems} />}

        <div className={`w-full  ${!isMobile && 'px-[16px] pt-[24px] pb-[100px]'}`}>
          {!hideDashboardLayout && (
            <div className={`w-full ${isMobile ? 'grid grid-cols-2 pt-[12px] px-[16px]' : 'mb-[16px] flex items-center'}`}>
              <div className={`${isMobile && 'w-full'} border-b-[3px] border-[#1814f3] flex items-center justify-center pb-[8px] text-16 font-500 w-[120px] text-[#1814f3] cursor-default`}>{translate('overview')}</div>
              <Link to={`/dashboard/event?from_date=&to_date=&event_id=${eventSelected}&ticket_platform=`}>
                <div className={`${isMobile && 'w-full'} flex items-center justify-center text-16 font-500 w-[120px] text-[#718ebf] cursor-pointer pb-[8px]`}>{translate('event')}</div>
              </Link>
            </div>
          )}

          <div className={`${isMobile ? 'px-[16px] py-[25px] grid grid-cols-1 gap-[16px]' : 'h-[268px] py-[24px] rounded-[8px] flex flex-col items-end'} w-full bg-[#a7b4fe]`}>
            <div className="flex items-center gap-x-[8px]">
              {
                showPlatform &&
                <div className={`${isMobile ? 'flex-1' : 'mt-[3px]'}`}>
                  <div className="text-[#262626] text-14 mb-[8px]" style={{ fontWeight: 500 }}>{translate('ticket_platform')}</div>

                  {
                    selectedPlatform &&
                    <Select
                      styles={{
                        input: (base) => ({
                          ...base,
                          "input:focus": {
                            boxShadow: "none",
                          },
                        })
                      }}
                      // defaultValue={ticketPlatformDefault}
                      value={selectedPlatform}
                      name="ticket_platform"
                      options={ticket_platform_option}
                      className="filter-item__select"
                      classNamePrefix="select"
                      placeholder={ticket_platform_option[0].label}
                      onChange={(e: any) => {
                        setTicketPlatform(e.value);
                        setFilter(true);
                        setSelectedPlatForm(e);
                      }} />
                  }

                </div>
              }

              <div className={`${isMobile ? 'w-[60%]' : 'w-[435px] mr-[22px] h-[68px]'}`}>
                <div className="text-14 font-500 text-left mb-[8px]">{translate('time')}</div>

                <div className="p-0">
                  <DateRangePicker
                    quickSelectDate={true}
                    isMobile={isMobile}
                    setApplyDate={setApplyDate}
                    setFilter={setFilter}
                    setSuffix={setSuffix}
                    setPage={setPage}
                    applyDate={applyDate}
                  />
                </div>
              </div>
            </div>

            {
              stats &&
              <div className={`${!isMobile && 'px-[22px]'} w-full mt-[16px] relative`}>
                {
                  !isMobile ?
                    <div className='w-full flex items-center'>
                      <button className="flex items-center justify-center size-[40px] rounded-full absolute bg-white border border-[#a7b4fe] cursor-pointer prev-arrow ml-[-15px] z-[40]">
                        <ArrowLeftIcon className="w-4 h-4 text-brand-500" />
                      </button>
                      <Swiper
                        slidesPerView={2}
                        spaceBetween={12}
                        slidesPerGroup={4}
                        className="!pb-10 sm:!pb-0"
                        grid={{
                          rows: 2,
                          fill: "row"
                        }}
                        navigation={{
                          nextEl: ".next-arrow",
                          prevEl: ".prev-arrow",
                          disabledClass: "opacity-0"
                        }}
                        pagination={{
                          el: "#bulletsContainer",
                          type: "bullets",
                          clickable: true,
                          renderBullet: function (index: number, className: string) {
                            return '<span class="' + className + '"></span>';
                          },
                          bulletClass: "sm:hidden !rounded-md !w-10 !h-2 bg-magnolia-400",
                          bulletActiveClass: "!bg-white",
                        }}
                        breakpoints={SLIDER_BREAKPOINT}
                        modules={[Navigation, Grid, Pagination]}
                      >
                        <SwiperSlide className="!h-auto">
                          <div className="w-[100%] h-[135px] px-[15px] py-[12px] rounded-[8px] bg-white flex justify-between gap-x-[8px]">
                            <div className="size-[50px] rounded-full flex items-center justify-center bg-[#ddfdcd]">
                              <img src="/images/icons/icon-money.svg" alt="icon-overview" />
                            </div>

                            <div className="flex-1">
                              <div className="flex text-13 mb-[4px] text-[#718ebf] gap-x-[4px]">
                                <div>{translate('gross-revenue')}</div>

                                <LightTooltip title={translate("tooltip-revenue")} className="w-[200px]" placement='top-start'>
                                  <img src="/images/icons/tooltip.svg" alt="icon-tooltip" className="size-[16px]" />
                                </LightTooltip>
                              </div>

                              <div className="info-main-value">
                                <div className='shorten'>{symbolCurrency} {shortenNumber(stats.total_subtotal)}</div>
                                {
                                  stats.total_subtotal > 0 ?
                                    <div className='full-number'>{symbolCurrency} {stats.total_subtotal.toLocaleString('de-DE')}</div>
                                    :
                                    <div className='full-number'>{symbolCurrency} 0</div>
                                }
                              </div>

                              {/* {
                                growth && growth.total_subtotal && growth.total_subtotal !== "0" &&
                                <div className={(growth.total_subtotal.indexOf('-') !== -1) ? "fluctuations reduce" : "fluctuations increase"}>
                                  <div className="fluctuation-percent">
                                    {
                                      growth.total_subtotal.indexOf('-') !== -1 ?
                                        <ArrowDownIcon className="w-3 h-3 icon-down" />
                                        :
                                        <ArrowUpIcon className="w-3 h-3 icon-up" />
                                    }

                                    {
                                      growth.total_subtotal === 'Infinity' ?
                                        <div>∞ {getSuffix()}</div>
                                        :
                                        <div>
                                          {getGrowthValue(growth.total_subtotal)}% {getSuffix()}
                                        </div>
                                    }
                                  </div>
                                </div>
                              } */}

                              {growth?.total_subtotal ? (
                                <React.Fragment>
                                  {growth?.total_subtotal !== "Infinity" ? (
                                    <>
                                      {Number(growth?.total_subtotal) !== 0 ? (
                                        <p
                                          className={twMerge(
                                            Number(growth?.total_subtotal) > 0
                                              ? "text-green-600"
                                              : Number(
                                                  growth?.total_subtotal
                                                ) < 0
                                              ? "text-red-600"
                                              : "",
                                            "flex items-baseline text-xs gap-x-0.5 sm:text-sm"
                                          )}
                                        >
                                          {Number(growth?.total_subtotal) >
                                          0 ? (
                                            <ArrowUpIcon
                                              className="size-4 flex-shrink-0 self-center text-green-500 font-semibold"
                                              aria-hidden="true"
                                            />
                                          ) : Number(growth?.total_subtotal) <
                                            0 ? (
                                            <ArrowDownIcon
                                              className="size-4 flex-shrink-0 self-center text-red-500 font-semibold"
                                              aria-hidden="true"
                                            />
                                          ) : (
                                            <></>
                                          )}
                                          {Math.abs(
                                            Math.floor(
                                              Number(growth?.total_subtotal)
                                            )
                                          )}
                                          % {getSuffix()}
                                        </p>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  ) : (
                                    <p className="text-sm text-green-600 flex items-baseline gap-x-0.5">
                                      <ArrowUpIcon
                                        className="h-4 w-4 flex-shrink-0 self-center text-green-500 font-semibold"
                                        aria-hidden="true"
                                      />
                                      ∞ vs {getSuffix()}
                                    </p>
                                  )}
                                </React.Fragment>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </SwiperSlide>

                        <SwiperSlide className='!h-auto'>
                          <div className="w-[100%] h-[135px] px-[15px] py-[12px] rounded-[8px] bg-white flex justify-between gap-x-[8px]">
                            <div className="size-[50px] rounded-full flex items-center justify-center bg-[#ffe0eb]">
                              <img src="/images/icons/icon-total-orders.svg" alt="icon-overview" />
                            </div>

                            <div className="flex-1">
                              <div className="flex text-13 mb-[4px] text-[#718ebf] gap-x-[4px]">
                                <div>{translate('orders')}</div>

                                <LightTooltip title={translate("tooltip-orders")} className="w-[200px]" placement='top-start'>
                                  <img src="/images/icons/tooltip.svg" alt="icon-tooltip" className="size-[16px]" />
                                </LightTooltip>
                              </div>

                              <div className="info-main-value">
                                <div className='shorten'>{shortenNumber(stats.total_orders, 'number')}</div>
                                {
                                  stats.total_orders > 0 ?
                                    <div className='full-number'>{stats.total_orders.toLocaleString('de-DE')}</div>
                                    :
                                    <div className='full-number'>0</div>
                                }
                              </div>

                              {/* {
                                growth && growth.total_orders && growth.total_orders !== "0" &&
                                <div className={(growth.total_orders.indexOf('-') !== -1) ? "fluctuations reduce" : "fluctuations increase"}>
                                  <div className="fluctuation-percent">
                                    {
                                      growth.total_orders.indexOf('-') !== -1 ?
                                        <ArrowDownIcon className="w-3 h-3 icon-down" />
                                        :
                                        <ArrowUpIcon className="w-3 h-3 icon-up" />
                                    }

                                    {
                                      growth.total_orders === 'Infinity' ?
                                        <div>∞ {getSuffix()}</div>
                                        :
                                        <div>{getGrowthValue(growth.total_orders)}% {getSuffix()}</div>
                                    }
                                  </div>
                                </div>
                              } */}

                              {growth?.total_orders ? (
                                <React.Fragment>
                                  {growth?.total_orders !== "Infinity" ? (
                                    <>
                                      {Number(growth?.total_orders) !== 0 ? (
                                        <p
                                          className={twMerge(
                                            Number(growth?.total_orders) > 0
                                              ? "text-green-600"
                                              : Number(
                                                  growth?.total_orders
                                                ) < 0
                                              ? "text-red-600"
                                              : "",
                                            "flex items-baseline text-xs gap-x-0.5 sm:text-sm"
                                          )}
                                        >
                                          {Number(growth?.total_orders) >
                                          0 ? (
                                            <ArrowUpIcon
                                              className="size-4 flex-shrink-0 self-center text-green-500 font-semibold"
                                              aria-hidden="true"
                                            />
                                          ) : Number(growth?.total_orders) <
                                            0 ? (
                                            <ArrowDownIcon
                                              className="size-4 flex-shrink-0 self-center text-red-500 font-semibold"
                                              aria-hidden="true"
                                            />
                                          ) : (
                                            <></>
                                          )}
                                          {Math.abs(
                                            Math.floor(
                                              Number(growth?.total_orders)
                                            )
                                          )}
                                          % {getSuffix()}
                                        </p>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  ) : (
                                    <p className="text-sm text-green-600 flex items-baseline gap-x-0.5">
                                      <ArrowUpIcon
                                        className="h-4 w-4 flex-shrink-0 self-center text-green-500 font-semibold"
                                        aria-hidden="true"
                                      />
                                      ∞ vs {getSuffix()}
                                    </p>
                                  )}
                                </React.Fragment>
                              ) : (
                                <></>
                              )}

                              <a href={`/orders`}>
                                <div className="text-12 cursor-pointer text-brand-500 font-600 mt-[4px]">{translate('view-more')}</div>
                              </a>
                            </div>
                          </div>
                        </SwiperSlide>

                        <SwiperSlide className='!h-auto'>
                          <div className="w-[100%] h-[135px] px-[15px] py-[12px] rounded-[8px] bg-white flex justify-between gap-x-[8px]">
                            <div className="size-[50px] rounded-full flex items-center justify-center bg-[#e7edff]">
                              <img src="/images/icons/icon-total-tickets.svg" alt="icon-overview" />
                            </div>

                            <div className="flex-1">
                              <div className="flex text-13 mb-[4px] text-[#718ebf] gap-x-[4px]">
                                <div>{translate('total-tickets')}</div>

                                <LightTooltip title={translate("tooltip-tickets")} className="w-[200px]" placement='top-start'>
                                  <img src="/images/icons/tooltip.svg" alt="icon-tooltip" className="size-[16px]" />
                                </LightTooltip>
                              </div>

                              <div className="info-main-value">
                                <div className='shorten'>{shortenNumber(stats.total_total_item, 'number')}</div>
                                {
                                  stats.total_total_item > 0 ?
                                    <div className='full-number'>{stats.total_total_item.toLocaleString('de-DE')}</div>
                                    :
                                    <div className='full-number'>0</div>
                                }
                              </div>

                              {/* {
                                growth && growth.total_total_item && growth.total_total_item !== "0" &&
                                <div className={(growth.total_total_item.indexOf('-') !== -1) ? "fluctuations reduce" : "fluctuations increase"}>
                                  <div className="fluctuation-percent">
                                    {
                                      growth.total_total_item.indexOf('-') !== -1 ?
                                        <ArrowDownIcon className="w-3 h-3 icon-down" />
                                        :
                                        <ArrowUpIcon className="w-3 h-3 icon-up" />
                                    }

                                    {
                                      growth.total_total_item === 'Infinity' ?
                                        <div>∞ {getSuffix()}</div>
                                        :
                                        <div>{getGrowthValue(growth.total_total_item)}% {getSuffix()}</div>
                                    }
                                  </div>
                                </div>
                              } */}

                              {growth?.total_total_item ? (
                                <React.Fragment>
                                  {growth?.total_total_item !== "Infinity" ? (
                                    <>
                                      {Number(growth?.total_total_item) !== 0 ? (
                                        <p
                                          className={twMerge(
                                            Number(growth?.total_total_item) > 0
                                              ? "text-green-600"
                                              : Number(
                                                  growth?.total_total_item
                                                ) < 0
                                              ? "text-red-600"
                                              : "",
                                            "flex items-baseline text-xs gap-x-0.5 sm:text-sm"
                                          )}
                                        >
                                          {Number(growth?.total_total_item) >
                                          0 ? (
                                            <ArrowUpIcon
                                              className="size-4 flex-shrink-0 self-center text-green-500 font-semibold"
                                              aria-hidden="true"
                                            />
                                          ) : Number(growth?.total_total_item) <
                                            0 ? (
                                            <ArrowDownIcon
                                              className="size-4 flex-shrink-0 self-center text-red-500 font-semibold"
                                              aria-hidden="true"
                                            />
                                          ) : (
                                            <></>
                                          )}
                                          {Math.abs(
                                            Math.floor(
                                              Number(growth?.total_total_item)
                                            )
                                          )}
                                          % {getSuffix()}
                                        </p>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  ) : (
                                    <p className="text-sm text-green-600 flex items-baseline gap-x-0.5">
                                      <ArrowUpIcon
                                        className="h-4 w-4 flex-shrink-0 self-center text-green-500 font-semibold"
                                        aria-hidden="true"
                                      />
                                      ∞ vs {getSuffix()}
                                    </p>
                                  )}
                                </React.Fragment>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </SwiperSlide>

                        <SwiperSlide className='!h-auto'>
                          <div className="w-[100%] h-[135px] px-[15px] py-[12px] rounded-[8px] bg-white flex justify-between gap-x-[8px]">
                            <div className="size-[50px] rounded-full flex items-center justify-center bg-[#e2f5f5]">
                              <img src="/images/icons/icon-net-revenue.svg" alt="icon-overview" />
                            </div>

                            <div className="flex-1">
                              <div className="flex text-13 mb-[4px] text-[#718ebf] gap-x-[4px]">
                                <div>{translate('net-revenue')}</div>

                                <LightTooltip title={translate("tooltip-net-revenue")} className="w-[200px]" placement="left">
                                  <img src="/images/icons/tooltip.svg" alt="icon-tooltip" className="size-[16px]" />
                                </LightTooltip>
                              </div>

                              <div className="info-main-value">
                                <div className='shorten'>{symbolCurrency} {shortenNumber(stats.total_grand_total)}</div>

                                {
                                  stats.total_grand_total > 0 ?
                                    <div className='full-number'>{symbolCurrency} {stats.total_grand_total.toLocaleString('de-DE')}</div>
                                    :
                                    <div className='full-number'>{symbolCurrency} 0</div>
                                }
                              </div>

                              {/* {
                                growth && growth.total_grand_total && growth.total_grand_total !== "0" &&
                                <div className={(growth.total_grand_total.indexOf('-') !== -1) ? "fluctuations reduce" : "fluctuations increase"}>
                                  <div className="fluctuation-percent">
                                    {
                                      growth.total_grand_total.indexOf('-') !== -1 ?
                                        <ArrowDownIcon className="w-3 h-3 icon-down" />
                                        :
                                        <ArrowUpIcon className="w-3 h-3 icon-up" />
                                    }

                                    {
                                      growth.total_grand_total === 'Infinity' ?
                                        <div>∞ {getSuffix()}</div>
                                        :
                                        <div>{getGrowthValue(growth.total_grand_total)}% {getSuffix()}</div>
                                    }
                                  </div>
                                </div>
                              } */}

                              {growth?.total_grand_total ? (
                                <React.Fragment>
                                  {growth?.total_grand_total !== "Infinity" ? (
                                    <>
                                      {Number(growth?.total_grand_total) !== 0 ? (
                                        <p
                                          className={twMerge(
                                            Number(growth?.total_grand_total) > 0
                                              ? "text-green-600"
                                              : Number(
                                                  growth?.total_grand_total
                                                ) < 0
                                              ? "text-red-600"
                                              : "",
                                            "flex items-baseline text-xs gap-x-0.5 sm:text-sm"
                                          )}
                                        >
                                          {Number(growth?.total_grand_total) >
                                          0 ? (
                                            <ArrowUpIcon
                                              className="size-4 flex-shrink-0 self-center text-green-500 font-semibold"
                                              aria-hidden="true"
                                            />
                                          ) : Number(growth?.total_grand_total) <
                                            0 ? (
                                            <ArrowDownIcon
                                              className="size-4 flex-shrink-0 self-center text-red-500 font-semibold"
                                              aria-hidden="true"
                                            />
                                          ) : (
                                            <></>
                                          )}
                                          {Math.abs(
                                            Math.floor(
                                              Number(growth?.total_grand_total)
                                            )
                                          )}
                                          % {getSuffix()}
                                        </p>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  ) : (
                                    <p className="text-sm text-green-600 flex items-baseline gap-x-0.5">
                                      <ArrowUpIcon
                                        className="h-4 w-4 flex-shrink-0 self-center text-green-500 font-semibold"
                                        aria-hidden="true"
                                      />
                                      ∞ vs {getSuffix()}
                                    </p>
                                  )}
                                </React.Fragment>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </SwiperSlide>

                        <SwiperSlide className='!h-auto'>
                          <div className="w-[100%] h-[135px] px-[15px] py-[12px] rounded-[8px] bg-white flex justify-between gap-x-[8px]">
                            <div className="size-[50px] rounded-full flex items-center justify-center bg-[#fff5d9]">
                              <img src="/images/icons/icon-total-discount.svg" alt="icon-overview" />
                            </div>

                            <div className="flex-1">
                              <div className="flex text-13 mb-[4px] text-[#718ebf] gap-x-[4px]">
                                <div>{translate('total-discount')}</div>

                                <LightTooltip title={translate("tooltip-discount")} className="w-[200px]" placement='top-start'>
                                  <img src="/images/icons/tooltip.svg" alt="icon-tooltip" className="size-[16px]" />
                                </LightTooltip>
                              </div>

                              <div className="info-main-value">
                                <div className='shorten'>{symbolCurrency} {shortenNumber(stats.total_discount_coupon)}</div>
                                {
                                  stats.total_discount_coupon > 0 ?
                                    <div className='full-number'>{symbolCurrency} {stats.total_discount_coupon.toLocaleString('de-DE')}</div>
                                    :
                                    <div className='full-number'>{symbolCurrency} 0</div>
                                }
                              </div>

                              {growth?.total_discount_coupon ? (
                                <React.Fragment>
                                  {growth?.total_discount_coupon !== "Infinity" ? (
                                    <>
                                      {Number(growth?.total_discount_coupon) !== 0 ? (
                                        <p
                                          className={twMerge(
                                            Number(growth?.total_discount_coupon) > 0
                                              ? "text-green-600"
                                              : Number(
                                                  growth?.total_discount_coupon
                                                ) < 0
                                              ? "text-red-600"
                                              : "",
                                            "flex items-baseline text-xs gap-x-0.5 sm:text-sm"
                                          )}
                                        >
                                          {Number(growth?.total_discount_coupon) >
                                          0 ? (
                                            <ArrowUpIcon
                                              className="size-4 flex-shrink-0 self-center text-green-500 font-semibold"
                                              aria-hidden="true"
                                            />
                                          ) : Number(growth?.total_discount_coupon) <
                                            0 ? (
                                            <ArrowDownIcon
                                              className="size-4 flex-shrink-0 self-center text-red-500 font-semibold"
                                              aria-hidden="true"
                                            />
                                          ) : (
                                            <></>
                                          )}
                                          {Math.abs(
                                            Math.floor(
                                              Number(growth?.total_discount_coupon)
                                            )
                                          )}
                                          % {getSuffix()}
                                        </p>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  ) : (
                                    <p className="text-sm text-green-600 flex items-baseline gap-x-0.5">
                                      <ArrowUpIcon
                                        className="h-4 w-4 flex-shrink-0 self-center text-green-500 font-semibold"
                                        aria-hidden="true"
                                      />
                                      ∞ vs {getSuffix()}
                                    </p>
                                  )}
                                </React.Fragment>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </SwiperSlide>

                        <SwiperSlide className='!h-auto'>
                          <div className="w-[100%] h-[135px] px-[15px] py-[12px] rounded-[8px] bg-white flex justify-between gap-x-[8px]">
                            <div className="size-[50px] rounded-full flex items-center justify-center bg-[#feefe7]">
                              <img src="/images/icons/icon-total-promotion.svg" alt="icon-overview" />
                            </div>

                            <div className="flex-1">
                              <div className="flex text-13 mb-[4px] text-[#718ebf] gap-x-[4px]">
                                <div>{translate('total-promotion')}</div>

                                <LightTooltip title={translate("tooltip-promotion")} className="w-[200px]" placement="left">
                                  <img src="/images/icons/tooltip.svg" alt="icon-tooltip" className="size-[16px]" />
                                </LightTooltip>
                              </div>

                              <div className="info-main-value">
                                <div className='shorten'>{symbolCurrency} {shortenNumber(stats.total_discount_promotion)}</div>
                                {
                                  stats.total_discount_promotion > 0 ?
                                    <div className='full-number'>{symbolCurrency} {stats.total_discount_promotion.toLocaleString('de-DE')}</div>
                                    :
                                    <div className='full-number'>{symbolCurrency} 0</div>
                                }
                              </div>

                              {growth?.total_discount_promotion ? (
                                <React.Fragment>
                                  {growth?.total_discount_promotion !== "Infinity" ? (
                                    <>
                                      {Number(growth?.total_discount_promotion) !== 0 ? (
                                        <p
                                          className={twMerge(
                                            Number(growth?.total_discount_promotion) > 0
                                              ? "text-green-600"
                                              : Number(
                                                  growth?.total_discount_promotion
                                                ) < 0
                                              ? "text-red-600"
                                              : "",
                                            "flex items-baseline text-xs gap-x-0.5 sm:text-sm"
                                          )}
                                        >
                                          {Number(growth?.total_discount_promotion) >
                                          0 ? (
                                            <ArrowUpIcon
                                              className="size-4 flex-shrink-0 self-center text-green-500 font-semibold"
                                              aria-hidden="true"
                                            />
                                          ) : Number(growth?.total_discount_promotion) <
                                            0 ? (
                                            <ArrowDownIcon
                                              className="size-4 flex-shrink-0 self-center text-red-500 font-semibold"
                                              aria-hidden="true"
                                            />
                                          ) : (
                                            <></>
                                          )}
                                          {Math.abs(
                                            Math.floor(
                                              Number(growth?.total_discount_promotion)
                                            )
                                          )}
                                          % {getSuffix()}
                                        </p>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  ) : (
                                    <p className="text-sm text-green-600 flex items-baseline gap-x-0.5">
                                      <ArrowUpIcon
                                        className="h-4 w-4 flex-shrink-0 self-center text-green-500 font-semibold"
                                        aria-hidden="true"
                                      />
                                      ∞ vs {getSuffix()}
                                    </p>
                                  )}
                                </React.Fragment>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </SwiperSlide>
                      </Swiper>
                      {/* Navigation */}
                      <button className="flex items-center justify-center size-[40px] rounded-full absolute bg-white border border-[#a7b4fe] right-[10px] cursor-pointer next-arrow z-[40]">
                        <ArrowRightIcon className="w-4 h-4 text-brand-500" />
                      </button>
                    </div>
                    :
                    <CarouselMobile
                      responsive={responsive}
                      infinite={true}
                      arrows={false}
                      showDots
                      customDot={<CustomDot />}
                    >
                      <div className="w-full pb-[8px]">
                        <div className="grid grid-cols-2 gap-x-[8px] flex justify-between w-full mb-[8px]">
                          <div className="w-full rounded-[8px] bg-white px-[12px] py-[20px]">
                            <div className="size-[50px] rounded-full flex items-center justify-center bg-[#ddfdcd]">
                              <img src="/images/icons/icon-money.svg" alt="icon-overview" />
                            </div>

                            <div className="carousel-info">
                              <div className="info-label">
                                <span>{translate('gross-revenue')}</span>

                                <LightTooltip title={translate("tooltip-revenue")} className="w-[200px]" placement='top-start'>
                                  <img src="/images/icons/tooltip.svg" alt="icon-tooltip" className="icon-tooltip" />
                                </LightTooltip>
                              </div>

                              <div className="info-main-value">
                                <span className='shorten'>{symbolCurrency} {shortenNumber(stats.total_subtotal)}</span>
                              </div>

                              {/* {
                                growth && growth.total_subtotal && growth.total_subtotal !== "0" &&
                                <div className={(growth.total_subtotal.indexOf('-') !== -1) ? "fluctuations reduce" : "fluctuations increase"}>
                                  <div className="fluctuation-percent">
                                    {
                                      growth.total_subtotal.indexOf('-') !== -1 ?
                                        <ArrowDownIcon className="w-3 h-3 icon-down" />
                                        :
                                        <ArrowUpIcon className="w-3 h-3 icon-up" />
                                    }

                                    {
                                      growth.total_subtotal === 'Infinity' ?
                                        <div>∞ {getSuffix()}</div>
                                        :
                                        <div>{getGrowthValue(growth.total_subtotal)}% {getSuffix()}</div>
                                    }
                                  </div>
                                </div>
                              } */}

                              {growth?.total_subtotal ? (
                                <React.Fragment>
                                  {growth?.total_subtotal !== "Infinity" ? (
                                    <>
                                      {Number(growth?.total_subtotal) !== 0 ? (
                                        <p
                                          className={twMerge(
                                            Number(growth?.total_subtotal) > 0
                                              ? "text-green-600"
                                              : Number(
                                                  growth?.total_subtotal
                                                ) < 0
                                              ? "text-red-600"
                                              : "",
                                            "flex items-baseline text-xs gap-x-0.5 sm:text-sm"
                                          )}
                                        >
                                          {Number(growth?.total_subtotal) >
                                          0 ? (
                                            <ArrowUpIcon
                                              className="size-4 flex-shrink-0 self-center text-green-500 font-semibold"
                                              aria-hidden="true"
                                            />
                                          ) : Number(growth?.total_subtotal) <
                                            0 ? (
                                            <ArrowDownIcon
                                              className="size-4 flex-shrink-0 self-center text-red-500 font-semibold"
                                              aria-hidden="true"
                                            />
                                          ) : (
                                            <></>
                                          )}
                                          {Math.abs(
                                            Math.floor(
                                              Number(growth?.total_subtotal)
                                            )
                                          )}
                                          % {getSuffix()}
                                        </p>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  ) : (
                                    <p className="text-sm text-green-600 flex items-baseline gap-x-0.5">
                                      <ArrowUpIcon
                                        className="h-4 w-4 flex-shrink-0 self-center text-green-500 font-semibold"
                                        aria-hidden="true"
                                      />
                                      ∞ vs {getSuffix()}
                                    </p>
                                  )}
                                </React.Fragment>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>

                          <div className="w-full rounded-[8px] bg-white px-[12px] py-[20px]">
                            <div className="size-[50px] rounded-full flex items-center justify-center bg-[#ffe0eb]">
                              <img src="/images/icons/icon-total-orders.svg" alt="icon-overview" />
                            </div>

                            <div className="carousel-info">
                              <div className="info-label">
                                <span>{translate('orders')}</span>

                                <LightTooltip title={translate("tooltip-orders")} className="w-[200px]" placement='top-start'>
                                  <img src="/images/icons/tooltip.svg" alt="icon-tooltip" className="icon-tooltip" />
                                </LightTooltip>
                              </div>

                              <div className="info-main-value">
                                <span className='shorten'>{shortenNumber(stats.total_orders, 'number')}</span>
                              </div>

                              {/* {
                                growth && growth.total_orders && growth.total_orders !== "0" &&
                                <div className={(growth.total_orders.indexOf('-') !== -1) ? "fluctuations reduce" : "fluctuations increase"}>
                                  <div className="fluctuation-percent">
                                    {
                                      growth.total_orders.indexOf('-') !== -1 ?
                                        <ArrowDownIcon className="w-3 h-3 icon-down" />
                                        :
                                        <ArrowUpIcon className="w-3 h-3 icon-up" />
                                    }
                                    {
                                      growth.total_orders === 'Infinity' ?
                                        <div>∞ {getSuffix()}</div>
                                        :
                                        <div>{getGrowthValue(growth.total_orders)}% {getSuffix()}</div>
                                    }
                                  </div>
                                </div>
                              } */}

                              {growth?.total_orders ? (
                                <React.Fragment>
                                  {growth?.total_orders !== "Infinity" ? (
                                    <>
                                      {Number(growth?.total_orders) !== 0 ? (
                                        <p
                                          className={twMerge(
                                            Number(growth?.total_orders) > 0
                                              ? "text-green-600"
                                              : Number(
                                                  growth?.total_orders
                                                ) < 0
                                              ? "text-red-600"
                                              : "",
                                            "flex items-baseline text-xs gap-x-0.5 sm:text-sm"
                                          )}
                                        >
                                          {Number(growth?.total_orders) >
                                          0 ? (
                                            <ArrowUpIcon
                                              className="size-4 flex-shrink-0 self-center text-green-500 font-semibold"
                                              aria-hidden="true"
                                            />
                                          ) : Number(growth?.total_orders) <
                                            0 ? (
                                            <ArrowDownIcon
                                              className="size-4 flex-shrink-0 self-center text-red-500 font-semibold"
                                              aria-hidden="true"
                                            />
                                          ) : (
                                            <></>
                                          )}
                                          {Math.abs(
                                            Math.floor(
                                              Number(growth?.total_orders)
                                            )
                                          )}
                                          % {getSuffix()}
                                        </p>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  ) : (
                                    <p className="text-sm text-green-600 flex items-baseline gap-x-0.5">
                                      <ArrowUpIcon
                                        className="h-4 w-4 flex-shrink-0 self-center text-green-500 font-semibold"
                                        aria-hidden="true"
                                      />
                                      ∞ vs {getSuffix()}
                                    </p>
                                  )}
                                </React.Fragment>
                              ) : (
                                <></>
                              )}

                              <a href="/orders">
                                <div className="text-12 cursor-pointer text-brand-500 font-600 mt-[4px]">{translate('view-more')}</div>
                              </a>
                            </div>
                          </div>
                        </div>

                        <div className="grid grid-cols-2 gap-x-[8px] flex justify-between w-full mb-[8px]">
                          <div className="w-full rounded-[8px] bg-white px-[12px] py-[20px]">
                            <div className="size-[50px] rounded-full flex items-center justify-center bg-[#e7edff]">
                              <img src="/images/icons/icon-total-tickets.svg" alt="icon-overview" />
                            </div>

                            <div className="carousel-info">
                              <div className="info-label">
                                <span>{translate('total-tickets')}</span>

                                <LightTooltip title={translate("tooltip-tickets")} className="w-[200px]" placement='top-start'>
                                  <img src="/images/icons/tooltip.svg" alt="icon-tooltip" className="icon-tooltip" />
                                </LightTooltip>
                              </div>

                              <div className="info-main-value">
                                <span className='shorten'>{shortenNumber(stats.total_total_item, 'number')}</span>
                              </div>

                              {/* {
                                growth && growth.total_total_item && growth.total_total_item !== "0" &&
                                <div className={(growth.total_total_item.indexOf('-') !== -1) ? "fluctuations reduce" : "fluctuations increase"}>
                                  <div className="fluctuation-percent">
                                    {
                                      growth.total_total_item.indexOf('-') !== -1 ?
                                        <ArrowDownIcon className="w-3 h-3 icon-down" />
                                        :
                                        <ArrowUpIcon className="w-3 h-3 icon-up" />
                                    }

                                    {
                                      growth.total_total_item === 'Infinity' ?
                                        <div>∞ {getSuffix()}</div>
                                        :
                                        <div>{getGrowthValue(growth.total_total_item)}% {getSuffix()}</div>
                                    }
                                  </div>
                                </div>
                              } */}

                              {growth?.total_total_item ? (
                                <React.Fragment>
                                  {growth?.total_total_item !== "Infinity" ? (
                                    <>
                                      {Number(growth?.total_total_item) !== 0 ? (
                                        <p
                                          className={twMerge(
                                            Number(growth?.total_total_item) > 0
                                              ? "text-green-600"
                                              : Number(
                                                  growth?.total_total_item
                                                ) < 0
                                              ? "text-red-600"
                                              : "",
                                            "flex items-baseline text-xs gap-x-0.5 sm:text-sm"
                                          )}
                                        >
                                          {Number(growth?.total_total_item) >
                                          0 ? (
                                            <ArrowUpIcon
                                              className="size-4 flex-shrink-0 self-center text-green-500 font-semibold"
                                              aria-hidden="true"
                                            />
                                          ) : Number(growth?.total_total_item) <
                                            0 ? (
                                            <ArrowDownIcon
                                              className="size-4 flex-shrink-0 self-center text-red-500 font-semibold"
                                              aria-hidden="true"
                                            />
                                          ) : (
                                            <></>
                                          )}
                                          {Math.abs(
                                            Math.floor(
                                              Number(growth?.total_total_item)
                                            )
                                          )}
                                          % {getSuffix()}
                                        </p>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  ) : (
                                    <p className="text-sm text-green-600 flex items-baseline gap-x-0.5">
                                      <ArrowUpIcon
                                        className="h-4 w-4 flex-shrink-0 self-center text-green-500 font-semibold"
                                        aria-hidden="true"
                                      />
                                      ∞ vs {getSuffix()}
                                    </p>
                                  )}
                                </React.Fragment>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>

                          <div className="w-full rounded-[8px] bg-white px-[12px] py-[20px]">
                            <div className="size-[50px] rounded-full flex items-center justify-center bg-[#e2f5f5]">
                              <img src="/images/icons/icon-net-revenue.svg" alt="icon-overview" />
                            </div>

                            <div className="carousel-info">
                              <div className="info-label">
                                <span>{translate('net-revenue')}</span>

                                <LightTooltip title={translate("tooltip-net-revenue")} className="w-[200px]" placement='top-start'>
                                  <img src="/images/icons/tooltip.svg" alt="icon-tooltip" className="icon-tooltip" />
                                </LightTooltip>
                              </div>

                              <div className="info-main-value">
                                <span className='shorten'>{symbolCurrency} {shortenNumber(stats.total_grand_total)}</span>
                              </div>

                              {/* {
                                growth && growth.total_grand_total && growth.total_grand_total !== "0" &&
                                <div className={(growth.total_grand_total.indexOf('-') !== -1) ? "fluctuations reduce" : "fluctuations increase"}>
                                  <div className="fluctuation-percent">
                                    {
                                      growth.total_grand_total.indexOf('-') !== -1 ?
                                        <ArrowDownIcon className="w-3 h-3 icon-down" />
                                        :
                                        <ArrowUpIcon className="w-3 h-3 icon-up" />
                                    }

                                    <span>{getGrowthValue(growth.total_grand_total)}% {getSuffix()}</span>
                                  </div>
                                </div>
                              } */}

                              {growth?.total_grand_total ? (
                                <React.Fragment>
                                  {growth?.total_grand_total !== "Infinity" ? (
                                    <>
                                      {Number(growth?.total_grand_total) !== 0 ? (
                                        <p
                                          className={twMerge(
                                            Number(growth?.total_grand_total) > 0
                                              ? "text-green-600"
                                              : Number(
                                                  growth?.total_grand_total
                                                ) < 0
                                              ? "text-red-600"
                                              : "",
                                            "flex items-baseline text-xs gap-x-0.5 sm:text-sm"
                                          )}
                                        >
                                          {Number(growth?.total_grand_total) >
                                          0 ? (
                                            <ArrowUpIcon
                                              className="size-4 flex-shrink-0 self-center text-green-500 font-semibold"
                                              aria-hidden="true"
                                            />
                                          ) : Number(growth?.total_grand_total) <
                                            0 ? (
                                            <ArrowDownIcon
                                              className="size-4 flex-shrink-0 self-center text-red-500 font-semibold"
                                              aria-hidden="true"
                                            />
                                          ) : (
                                            <></>
                                          )}
                                          {Math.abs(
                                            Math.floor(
                                              Number(growth?.total_grand_total)
                                            )
                                          )}
                                          % {getSuffix()}
                                        </p>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  ) : (
                                    <p className="text-sm text-green-600 flex items-baseline gap-x-0.5">
                                      <ArrowUpIcon
                                        className="h-4 w-4 flex-shrink-0 self-center text-green-500 font-semibold"
                                        aria-hidden="true"
                                      />
                                      ∞ vs {getSuffix()}
                                    </p>
                                  )}
                                </React.Fragment>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="carousel-page">
                        <div className="grid grid-cols-2 gap-x-[8px] flex justify-between w-full mb-[8px]">
                          <div className="w-full rounded-[8px] bg-white px-[12px] py-[20px]">
                            <div className="size-[50px] rounded-full flex items-center justify-center bg-[#fff5d9]">
                              <img src="/images/icons/icon-total-discount.svg" alt="icon-overview" />
                            </div>

                            <div className="carousel-info">
                              <div className="info-label">
                                <span>{translate('total-discount')}</span>

                                <LightTooltip title={translate("tooltip-discount")} className="w-[200px]" placement='top-start'>
                                  <img src="/images/icons/tooltip.svg" alt="icon-tooltip" className="icon-tooltip" />
                                </LightTooltip>
                              </div>

                              <div className="info-main-value">
                                <span className='shorten'>{symbolCurrency} {shortenNumber(stats.total_discount_coupon)}</span>
                              </div>

                              {growth?.total_discount_coupon ? (
                                <React.Fragment>
                                  {growth?.total_discount_coupon !== "Infinity" ? (
                                    <>
                                      {Number(growth?.total_discount_coupon) !== 0 ? (
                                        <p
                                          className={twMerge(
                                            Number(growth?.total_discount_coupon) > 0
                                              ? "text-green-600"
                                              : Number(
                                                  growth?.total_discount_coupon
                                                ) < 0
                                              ? "text-red-600"
                                              : "",
                                            "flex items-baseline text-xs gap-x-0.5 sm:text-sm"
                                          )}
                                        >
                                          {Number(growth?.total_discount_coupon) >
                                          0 ? (
                                            <ArrowUpIcon
                                              className="size-4 flex-shrink-0 self-center text-green-500 font-semibold"
                                              aria-hidden="true"
                                            />
                                          ) : Number(growth?.total_discount_coupon) <
                                            0 ? (
                                            <ArrowDownIcon
                                              className="size-4 flex-shrink-0 self-center text-red-500 font-semibold"
                                              aria-hidden="true"
                                            />
                                          ) : (
                                            <></>
                                          )}
                                          {Math.abs(
                                            Math.floor(
                                              Number(growth?.total_discount_coupon)
                                            )
                                          )}
                                          % {getSuffix()}
                                        </p>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  ) : (
                                    <p className="text-sm text-green-600 flex items-baseline gap-x-0.5">
                                      <ArrowUpIcon
                                        className="h-4 w-4 flex-shrink-0 self-center text-green-500 font-semibold"
                                        aria-hidden="true"
                                      />
                                      ∞ vs {getSuffix()}
                                    </p>
                                  )}
                                </React.Fragment>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>

                          <div className="w-full rounded-[8px] bg-white px-[12px] py-[20px]">
                            <div className="size-[50px] rounded-full flex items-center justify-center bg-[#feefe7]">
                              <img src="/images/icons/icon-total-promotion.svg" alt="icon-overview" />
                            </div>

                            <div className="carousel-info">
                              <div className="info-label">
                                <span>{translate('total-promotion')}</span>

                                <LightTooltip title={translate("tooltip-promotion")} className="w-[200px]" placement='top-start'>
                                  <img src="/images/icons/tooltip.svg" alt="icon-tooltip" className="icon-tooltip" />
                                </LightTooltip>
                              </div>

                              <div className="info-main-value">
                                <span className='shorten'>{symbolCurrency} {shortenNumber(stats.total_discount_promotion)}</span>
                              </div>

                              {growth?.total_discount_promotion ? (
                                <React.Fragment>
                                  {growth?.total_discount_promotion !== "Infinity" ? (
                                    <>
                                      {Number(growth?.total_discount_promotion) !== 0 ? (
                                        <p
                                          className={twMerge(
                                            Number(growth?.total_discount_promotion) > 0
                                              ? "text-green-600"
                                              : Number(
                                                  growth?.total_discount_promotion
                                                ) < 0
                                              ? "text-red-600"
                                              : "",
                                            "flex items-baseline text-xs gap-x-0.5 sm:text-sm"
                                          )}
                                        >
                                          {Number(growth?.total_discount_promotion) >
                                          0 ? (
                                            <ArrowUpIcon
                                              className="size-4 flex-shrink-0 self-center text-green-500 font-semibold"
                                              aria-hidden="true"
                                            />
                                          ) : Number(growth?.total_discount_promotion) <
                                            0 ? (
                                            <ArrowDownIcon
                                              className="size-4 flex-shrink-0 self-center text-red-500 font-semibold"
                                              aria-hidden="true"
                                            />
                                          ) : (
                                            <></>
                                          )}
                                          {Math.abs(
                                            Math.floor(
                                              Number(growth?.total_discount_promotion)
                                            )
                                          )}
                                          % {getSuffix()}
                                        </p>
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  ) : (
                                    <p className="text-sm text-green-600 flex items-baseline gap-x-0.5">
                                      <ArrowUpIcon
                                        className="h-4 w-4 flex-shrink-0 self-center text-green-500 font-semibold"
                                        aria-hidden="true"
                                      />
                                      ∞ vs {getSuffix()}
                                    </p>
                                  )}
                                </React.Fragment>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>

                        </div>
                      </div>
                    </CarouselMobile>
                }

              </div>
            }

          </div>

          {
            (token !== '' && showEvent) &&
            <OverviewEvent
              translate={translate}
              applyDate={applyDate}
              page={page}
              setPage={setPage}
              setLoading={setLoading}
              setFilter={setFilter}
              filter={filter}
              shortenNumber={shortenNumber}
              language={language}
              isMobile={isMobile}
              setEventSelected={setEventSelected}
              setEventID={setEventID}
              eventID={eventID}
              eventStatus={eventStatus}
              setEventStatus={setEventStatus}
              navigate={navigate}
              symbolCurrency={symbolCurrency}
              currentCurrency={currentCurrency}
              ticketPlatform={ticketPlatform}
              LightTooltip={LightTooltip}
              token={token}
            />
          }

          {
            (token !== '') &&
            <ChartOverview
              translate={translate}
              language={language}
              isMobile={isMobile}
              setLoading={setLoading}
              dateType={dateType}
              setDateType={setDateType}
              dateValue={dateValue}
              setDateValue={setDateValue}
              currentCurrency={currentCurrency}
              showPlatform={showPlatform}
              token={token}
            />
          }
        </div>
        {
          loading &&
          <FullScreenLoading />
        }
      </div>
    )
  } else {
    return <></>
  }

}

export default WPSDashboardOverview;
